import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import moment from "moment";
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {route} from "../../../routes";
import {
  withRouter,
  GelContentContainer,
  GelContentColumn,
  GelContentRow,
  HeroBlock,
  ResultsListing,
  withCourseSearchApi, withAuthentication, FormUtility, Notice, ApiPager
} from "cw-styleguide-react";
import ResultsFilterForm from "../components/ResultsFilterForm";
import i18n from "../../../i18n";
import Helmet from 'react-helmet';

class ResultsView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.results.metaTitle')} | {this.props.t('app.name')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('results') + this.props.query}>
          {this.props.t('view.results.breadcrumb')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('view.results.title')}</h1>
        </GelContentContainer>
        <HeroBlock>
          <p>{this.props.t('view.results.introduction')}</p>
        </HeroBlock>

        <GelContentContainer>

          {i18n.language === 'cy' &&

              <Notice type={'info-icon'}>
                <span>{ this.props.t('view.results.messages.languageDisclaimer')}</span>
              </Notice>

          }

          <GelContentRow>
            <GelContentColumn xs={12} sm={12} md={4} lg={4} mdPush={8} lgPush={8}>
              <ResultsFilterForm {...this.props}/>
            </GelContentColumn>
            <GelContentColumn xs={12} sm={12} md={8} lg={8} mdPull={4} lgPull={4}>

              <ApiPager
                authorize={false}
                onReloadResetPage={true}
                api={this.props.courseSearchApiGetEndpoint('course_search_api_course_q')}
                filters={{
                  courseId: this.props.filterValues.courseId,
                  courseTitle: this.props.filterValues.courseTitle,
                  keyword: this.props.filterValues.keyword,
                  location: this.props.filterValues.location,
                  proximity: this.props.filterValues.location && this.props.filterValues.proximity ? this.props.filterValues.proximity : "" ,
                  qualificationType: Array.from(this.props.filterValues.qualificationType),
                  studyMethodType: Array.from(this.props.filterValues.studyMethodType),
                  studyMethodHours: Array.from(this.props.filterValues.studyMethodHours),
                  studyMethodTimes: Array.from(this.props.filterValues.studyMethodTimes),
                  programme: Array.from(this.props.filterValues.programme),
                  courseType: Array.from(this.props.filterValues.courseType),
                  courseGroupType: Array.from(this.props.filterValues.courseGroupType),
                  provider: this.props.filterValues.mainProviderId
                }}
                handleStateChange={this.props.handleStateChange}
                autoReload={false}
                sortOptions={[
                  {
                    value: 'titleAsc',
                    label: this.props.t('local:view.results.order.options.titleAsc')
                  },
                  {
                    value: 'titleDesc',
                    label: this.props.t('local:view.results.order.options.titleDesc')
                  },
                  {
                    value: 'locationAsc',
                    label: this.props.t('local:view.results.order.options.locationAsc')
                  },
                  {
                    value: 'locationDesc',
                    label: this.props.t('local:view.results.order.options.locationDesc')
                  },
                  {
                    value: 'dateAsc',
                    label: this.props.t('local:view.results.order.options.dateAsc')
                  },
                  {
                    value: 'dateDesc',
                    label: this.props.t('local:view.results.order.options.dateDesc')
                  }


                ]}
                initialOrder={this.props.filterValues['order']}
                initialPage={this.props.filterValues['page']}
                initialGroupSize={this.props.filterValues['groupSize']}
                stateReload={false}
                reloadKey={this.props.reloadKey}
                noResultsText={this.props.t('view.results.messages.noResults')}
                hasResultsText={''}

                render={(course) => ( <ResultsListing key={course.id} to={route('detail', {course: FormUtility.slugify(course.title) + '-' + course.id})}
                                                        title={course.title} meta={[

                  {key: this.props.t('view.results.fields.provider'), value: course.cw_courseprovidername ? course.cw_courseprovidername : null},
                  {key: this.props.t('view.results.fields.location'), value: course.townCity ? course.townCity.join(', ') : null},
                  {key: this.props.t('view.results.fields.qualification'), value: course.qualifications ? course.qualifications.join(', ') : null},
                  {key: this.props.t('view.results.fields.studyMethodType'), value: course.studyMethodType ? course.studyMethodType.map((hours) => {
                        return this.props.filters.studyMethodTypeLookup[hours]
                      }).join(', ') : null},
                  {key: this.props.t('view.results.fields.studyMethodHours'), value: course.studyMethodHours ? course.studyMethodHours.map((hours) => {
                      return this.props.filters.studyMethodHoursLookup[hours]
                    }).join(', ') : null},
                  {key: this.props.t('view.results.fields.studyMethodTimes'), value: course.studyMethodTimes ? course.studyMethodTimes.map((hours) => {
                      return this.props.filters.studyMethodTimesLookup[hours]
                    }).join(', ') : null},
                  {key: this.props.t('view.results.fields.startDate'), value: course.startDate ? [...new Set(course.startDate.map(detail => moment(detail).isValid() ? moment(detail).format('DD/MM/YYYY') : detail))].join(', ') : this.props.t('view.results.fields.seeStartDetails')}

                ].filter(data => data.value)}/>)}/>



            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withCourseSearchApi(process.env)(withAuthentication(withRouter(withTranslation('local')(ResultsView))));
